<template>
  <div class="hellos">
    <div style="width: 100%" :height="bannerHeight + 'px'" class="header">
      <h3>通知公告</h3>
      <h3>Qualification inquiry</h3>
    </div>
    <div class="center">
      <div class="Newsconsultation">
        <div class="tab">
          <p
            class="fh"
            style="color: #818181; font-size: 16px"
            @click="return_fn()"
          >
            <span style="color: #000">首页</span>&nbsp;&nbsp;
            <i class="el-icon-arrow-right"></i> &nbsp;通知公告
          </p>
        </div>
      </div>

      <div class="details">
        <img
          class="fh"
          @click="return_fn()"
          style="height: 20px; width: 20px; margin: 10px 0 0 50px"
          src="../image/iframe/fh.png"
          alt=""
        />
        <div
          class="details_div"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255)"
        >
          <h2 class="p_title">
            {{ s_title }}
          </h2>
          <p style="font-size: 14px; color: #999">
            <i class="el-icon-time" style="margin-right: 7px"></i>{{ pub_time }}
          </p>
          <div
            style="
              float: left;
              padding-top: 10px;
              white-space: pre-wrap;
              overflow: auto;
            "
            class="p_content"
            v-html="s_conter"
          ></div>
        </div>
      </div>
      <div v-show="ret_fn" style="height: 120px"></div>
    </div>
    <Foot class="foot" />
  </div>
</template>
  
  <script>
import Foot from "./Foot.vue";
import {
  getqueryPageInfo,
  getHomeNoticeList,
  getDeleteNotice,
  getDeployNotice,
  getRevoke,
  getDetailById,
} from "@/api/api.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { mapState } from "vuex";
export default {
  components: { Foot },
  computed: {
    ...mapState(["screenHeight"]),
  },

  data() {
    return {
      loading: false,

      s_title: "",
      s_conter: "",
      pub_time: "",
      ret_fn: false,
      ulshow: true,
      tableData: [],
      zwsjulshow: false,
      currentPage: 1, //当前页
      pageSize: 10, //当前页容量
      total: null, //总数
    };
  },

  created() {
    this.bannerHeight = (730 / 2560) * document.body.clientWidth;
    this.loading = true;
    if (
      /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
      typeof window.orientation !== "undefined"
    ) {
      this.$store.state.indexActive = ""
      sessionStorage.removeItem('index')
      this.loading = false;
      this.$router.push({
        path: "/phoneRotation",
        query: { id: this.$route.query.id },
      });
    }
    if (this.$route.query.id) {
      this.$store.state.indexActive = 57
      this.details(this.$route.query.id);
    } else {
      this.details(sessionStorage.getItem("ids"));
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.bannerHeight = (730 / 2560) * document.body.clientWidth;
      })();
    };
    // if (
    //   /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
    //   typeof window.orientation !== "undefined"
    // ) {
    //   this.$router.push("/phoneRotation");
    // }
    // that.setSize();
  },

  methods: {
    return_fn() {
      // this.ulshow = true;
      // this.ret_fn = false;
      // this.initTable();
      this.$store.state.indexActive = 57;
      sessionStorage.setItem("index", 57);
      sessionStorage.removeItem('ids')
      this.$router.push({ path: "/Rotation" });
    },
    details(item) {
        // this.$store.state.indexActive = '';
        // sessionStorage.removeItem('index')
      // this.$router.push({path:"/rotationLook",query:{
      //   id:item
      // }})
      sessionStorage.setItem("ids", item);
      this.loading = true;
      getDetailById(`${item}&type=Y`).then((res) => {
        if (res.code == 1000) {
          this.s_title = res.data.notice_title;
          this.s_conter = res.data.notice_content;
          this.pub_time = res.data.pub_time.slice(0, 10);
          document.getElementById("app").scrollTop = 0;

          this.loading = false;
        }
      });
    },

    initTable() {
      this.zwsjulshow = true;
      this.ulshow = false;
      let page = {
        size: this.pageSize,
        page: this.currentPage,
      };
      getHomeNoticeList(page)
        .then((res) => {
          if (res.code == 1000) {
            // console.log(res.data.list);
            if (res.data.list.length != 0) {
              this.tableData = res.data.list;
              // this.$forceUpdate();
              this.tableData.forEach((item) => {
                // console.log(item.pub_time);
                item.pub_time = item.pub_time.slice(0, 10);
              });
              this.total = res.data.total; //总条数
              this.pageSize = res.data.pageSize; //
              this.currentPage = res.data.pageNum; //
              // this.tableData=[]
              if (this.tableData.length == 0) {
                this.ulshow = false;
                this.zwsjulshow = true;
              } else {
                this.ulshow = true;
                this.zwsjulshow = false;
              }
            } else {
              this.tableData = [];
              this.ulshow = false;
              this.zwsjulshow = true;
            }
            console.log(this.tableData);
          } else {
            this.$notify.error({
              title: "提示",
              message: "res.msg",
            });
          }
        })
        .catch(() => {
          this.tableData = [];
          this.ulshow = false;
          this.zwsjulshow = true;
        });
    },

    handleSizeChange(val) {
      console.log("每页：${val}条");
      this.pageSize = val;
      this.initTable();
    },
    //分页 -- 当前页数
    handleCurrentChange(val) {
      console.log("当前：页${val}条");
      this.currentPage = val;
      this.initTable();
    },
  },
};
</script>
  
  
  <style scoped lang="less">
html,
body {
  background: #f6f8fe !important;
}
::v-deep img {
  max-width: 100% !important;
}
.p_title {
  line-height: 80px;
  font-size: 20px;
}
.header {
  padding-top: 140px;
  box-sizing: border-box;
  min-height: 450px;
  font-size: 40px;
  text-align: left;
  background: url("../assets/newBanner.png") 100% 100% no-repeat;
  background-size: 100% 100%;
  color: #000;
  h3 {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
    font-weight: normal;
  }
  :last-child {
    font: lighter 50px/80px PMingLiU;
    color: #c5c4c4;
    // font-style: SourceHanSansCN-Light;
  }
}

.p_content {
  line-height: 30px;
  width: 100%;
  word-wrap: break-word;
  color: #000;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: left;

  .ql-align-justify {
    font-size: 14px;
  }
  img {
    width: 100% !important;
  }
  table {
    max-width: 100%;
  }
  p {
    font-size: 14px;
    word-wrap: break-word;
    width: 1000px;
    white-space: initial;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 250px;
    text-align: left;
  }
}

.hellos {
  width: 100%;

  // background: rgb(246, 246, 246);
  // position: relative;
}

.details {
  // cursor: pointer;
  margin-top: 6px;
  display: flex;
  justify-content: center;
  // align-items: center;
  // padding: 30px;

  .details_div {
    // background: rgb(249, 249, 249);
    width: 1200px;
    min-height: 405px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  margin: auto;
  text-align: center;
}

.times {
  display: inline-block;
  height: 30px;
  width: 150px;
  display: flex;
  padding-left: 10px;
  justify-content: center;
  align-items: center;
  color: #666;
  // background: url(../image/iframe/times.png) no-repeat left;
}

.p_lod {
  width: 90%;
  margin: auto;
}

.Newsconsultation_nes {
  background: rgb(249, 249, 249);

  p {
    // margin-top: 30px;
    line-height: 30px;
  }
}
.article {
  margin-left: 10px;
  margin-right: 10px;
  text-align: left;
}

.p_first {
  height: 50px;
  display: flex;

  align-items: center;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;

  :nth-child(1) {
    font-weight: bold;
    font-size: 16px;
    color: #666;
  }
}

.ul {
  width: 100%;
  // background: rgb(255, 255, 255);
  border-radius: 3px;
  margin-bottom: 20px;

  li:hover {
    // box-shadow: 0px 0px 5px rgb(0, 150, 255); /* 边框阴影 */
    // -moz-box-shadow: 0px 0px 5px #888888; /* 老的 Firefox */
    border-radius: 3px;
  }

  li {
    width: 100%;
    margin-top: 30px;
    margin-block: 20px;
    position: relative;
    border-bottom: 1px dashed #aeadad;
    // box-shadow:2px 3px 10px 2px rgba(0,0,0,0.1);
    //       transition-duration:0.1s;
    //             transition-timing-function:linear;
    //             transition-delay:0s;
    //             transition-property:all;

    dl {
      display: flex;
      justify-content: space-between;

      align-items: flex-start;
      // height: 130px;

      dd {
        width: 100%;
        display: flex;
        flex-direction: column;
        p:nth-child(2) {
          padding-left: 10px;
          padding-right: 120px;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*超出3行部分显示省略号，去掉该属性 显示全部*/
          -webkit-box-orient: vertical;
        }

        p:nth-child(2) {
          position: relative;
          line-height: 30px;
          max-height: 60px;
          overflow: hidden;
          font-size: 15px;
        }

        p:nth-child(2)::after {
          position: absolute;
          bottom: 0;
          right: 0;
          padding-left: 40px;

          background: -webkit-linear-gradient(left, transparent, #fff 55%);

          background: -o-linear-gradient(right, transparent, #fff 55%);

          background: -moz-linear-gradient(right, transparent, #fff 55%);

          background: linear-gradient(to right, transparent, #fff 55%);
        }

        p {
          // display: contents;
          line-height: 30px;
          color: #999999;
        }

        div {
          // float: left;
          height: 36px;
          margin-left: 20px;
          width: 110px;
          font-size: 14;
          display: flex;
          justify-content: center;
          align-items: center;
          // background: rgb(0, 155, 255);
          color: rgb(255, 255, 255);
        }
      }

      dt {
        height: 100%;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.Newsconsultation {
  width: 1200px;
  margin: auto;
  // background: rgb(246, 246, 246);

  .tab {
    display: flex;
    // background: rgb(246, 246, 246);
    padding: 10px 0 28px 0;
    align-items: center;
    margin-top: 15px;
    color: #333;
    border-bottom: 1px solid #b4b2b2;

    div {
      display: flex;
    }

    h2 {
      margin-left: 10px;
    }

    .fh {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      margin-left: 10px;
      color: "#999999";
    }

    .bac {
      width: 8px;
      height: 25px;
      background: rgb(242, 242, 242);
    }
  }
}

.details {
  margin-left: 10px;
  margin-bottom: 10px;

  /deep/.el-pagination.is-background .btn-next {
    //margin: 0 5px;
    background-color: #0e1423;
    color: #8eb1cc;
    min-width: 68px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #4581ae;
  }
}

.pagination /deep/.el-pagination.is-background .btn-prev {
  //margin: 0 5px;
  background-color: #0e1423;
  color: #8eb1cc;
  min-width: 68px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #4581ae;
}

.pagination /deep/.el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #0e1423; // 进行修改未选中背景和字体
  color: #8fb1d2;
  border: 1px solid #4581ae;
  border-radius: 5px;
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.pagination
  /deep/.el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #2b597d;
  color: #cafbfd; //修改选中后的样式
}

/deep/ li.active {
  background: #409eff !important;
  color: #fff;
  border-radius: 50%;
}

/* 分页
   */
/* 上一页的css  */
.pagination /deep/.btn-prev {
  width: 100px !important;
  height: 48px !important;

  border-radius: 2px;
  margin: 0%;
  padding: 0px;
  background: #f0f0f0;
  color: #255676 !important;
  font-weight: 600;
  margin-right: 10px !important;
}

/* 下一页的css  */
.pagination /deep/.btn-next {
  background: #f0f0f0;
  width: 100px !important;
  height: 48px !important;

  border-radius: 2px;
  margin: 0%;
  padding: 0px;

  margin-left: 10px !important;
}

/* 中间页数的css  */
.pagination /deep/.el-pager li {
  width: 48px;
  height: 48px;
  // background: rgb(246, 246, 246);
  font-size: 18px;
}

/* 页码数字 */
.pagination /deep/.number {
  width: 48px !important;
  height: 48px !important;

  line-height: 48px !important;
}

/* 当前页的 提示  */
.pagination /deep/.el-pager li.active {
  color: white;
}

/*  总条数的 样式css   */
.pagination /deep/.el-pagination__total {
  /* background-color: #050F23; */
  /* width: 48px !important; */
  height: 48px !important;
  text-align: center;
  /* border: 1px solid #64DEFB; */
  font-size: 18px !important;
  margin-top: 10px;
  margin-left: 10px;
}

/* 每页的 展示条数 的 css   */
.el-pagination__sizes > input {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
}

.el-pagination .el-select .el-input .el-input__inner {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
}
.pagination/deep/ .el-icon-more {
  margin-top: 10px !important;
}

.pagination/deep/ .el-icon-d-arrow-left {
  margin-top: 10px !important;
}

.pagination/deep/ .el-icon-d-arrow-right {
  margin-top: 10px !important;
}

/* 前往的 css  */
.el-pagination__jump {
  font-size: 20px !important;
  margin-left: 10px !important;
  /* margin-right: 10px !important; */
}

/* 前往的 页码 css   */
.el-pagination__editor.el-input > input {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
  margin-left: 10px !important;
}

.center {
  background: #fff;
  width: 100%;
  // height: calc(100vh - 500px);
  overflow-y: auto;

  // position: relative;
}

.foot {
  // position: absolute;
  bottom: 0;
}

// 在填充数据之前隐藏
[v-cloak] {
  display: none;
}

//上一页和下一页的样式
</style>